import type { IconSvgObject } from './types';

const CurtainsIcon: IconSvgObject = [
  ["path", { d: "M22 3H2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 14C5.5985 13.2925 6.76719 11.3937 7 9M19 14C18.4015 13.2925 17.2328 11.3937 17 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 3V21H8C8 18.5 7.6 16.0669 6 14M3 14.5C9 14.5 12 8.5 12 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21 3V14.5M21 14.5V21H16C16 18.5 16.4 16.0669 18 14M21 14.5C15 14.5 12 8.5 12 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CurtainsIcon;
